import {Component, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {PaginationComponent} from '../../../shared/components/pagination/pagination.component';
import {LoadingComponent} from '../../../shared/components/loading/loading.component';
import {AlertComponent} from '../../../shared/components/alert/alert.component';
import {RouterLink} from '@angular/router';
import {
  createPaginationState,
  setPaginationLoading,
  updatePaginationFromResult,
} from '../../../core/helpers/pagination-state.helper';
import {UserGroupService} from '../../../core/services/user/user-group.service';
import {QueryUserGroupModel} from '../../../core/models/user/query-user-group.model';
import {ButtonComponent} from '../../../shared/components/button/button.component';
import {FeatherPipe} from '../../../core/pipes/feather.pipe';

@Component({
  selector: 'app-user-group-list',
  imports: [
    CommonModule,
    TranslateModule,
    PaginationComponent,
    LoadingComponent,
    AlertComponent,
    RouterLink,
    ButtonComponent,
    FeatherPipe
  ],
  templateUrl: './user-group-list.component.html',
  styleUrl: './user-group-list.component.scss'
})
export class UserGroupListComponent implements OnInit {
  error: string | null = null;
  groups: QueryUserGroupModel[] = [];
  readonly paginationState = createPaginationState();

  constructor(private readonly userGroupService: UserGroupService) {}

  ngOnInit(): void {
    this.onPageChange(0, 10);
  }

  onPageChange = (page: number, pageSize: number): void => {
    setPaginationLoading(this.paginationState, true);
    this.error = null;
    this.userGroupService.getUserGroups(page, pageSize).subscribe({
      next: (result) => {
        this.groups = result.content;
        updatePaginationFromResult(this.paginationState, result, pageSize);
      },
      error: (err) => {
        this.error = 'Falha ao carregar os grupos de usuário.';
        setPaginationLoading(this.paginationState, false);
        console.error(err);
      }
    });
  }
}
